export enum OddValueChange {
    'up1' = 1,
    'up2' = 2,
    'down1' = -1,
    'down2' = -2,
}
